import React, {useEffect, useState} from 'react';
import {Button, Form, Grid, Modal, Select} from "semantic-ui-react";
import {useForm} from "react-hook-form";
import {fetchCourseCategories, putCourses} from "../../../../../redux/actions";
import {Editor} from "@tinymce/tinymce-react";

const token = sessionStorage.getItem('Token')

export const CourseForm = ({show, item, onCancel, onSuccess}) => {

    const [categories, setCategories] = useState([]);
    const {register, handleSubmit, setValue, formState, watch} = useForm({
        mode: "onBlur",
        defaultValues: {...item}
    });

    const free = watch('free');

    useEffect(() => {
        register('course_category_id');
        register('free');
        register('discount');
        register('content');
        register('active');
    }, [register])

    useEffect(() => {
        async function getData() {
            try {
                const res = await fetchCourseCategories({active: 1, product: 1});

                const options = res.data
                    .map(function (row) {
                        return {
                            key: row.id,
                            text: row.name,
                            value: row.id,
                        };
                    });
                setCategories(options);
            } catch (e) {
                console.log(e);
            }
        }

        // noinspection JSIgnoredPromiseFromCall
        getData();
    }, [token]);

    const onSubmit = async data => {

        try {
            let values = {...data};
            if (values.free === '1') {
                values.price = 0;
            }

            const res = await putCourses(values);

            onSuccess(res);
        } catch (e) {
            alert('error')
        }
    };

    const sn = [
        {key: '1', text: 'Sim', value: '1'},
        {key: '0', text: 'Não', value: '0'},
    ]

    return (
        <Modal open={show} size={'large'}>
            <Modal.Header>Editar Produto</Modal.Header>
            <Modal.Content>
                <Modal.Description>
                    <Form id={'form'} onSubmit={handleSubmit(onSubmit)} loading={formState.isSubmitting}>
                        <Grid>
                            <Grid.Row columns={2}>
                                <Grid.Column>
                                    <input type={'hidden'} name={'id'} defaultValue={item.id || ''} ref={register()}/>
                                    <Form.Field>
                                        <label>Categoria</label>
                                        <Select
                                            name={'course_category_id'}
                                            placeholder='Selecione uma Categoria'
                                            options={categories}
                                            selectOnBlur={false}
                                            clearable
                                            defaultValue={item.course_category_id}
                                            onChange={(e, {value}) => {
                                                setValue('course_category_id', value);
                                            }}
                                        />
                                    </Form.Field>
                                    <Form.Field>
                                        <label>Nome</label>
                                        <input
                                            name={'name'}
                                            defaultValue={item.name}
                                            ref={register({required: true})}
                                            autoFocus
                                        />
                                    </Form.Field>
                                    <Form.Group widths={"equal"}>
                                        <Form.Field>
                                            <Form.Select
                                                fluid
                                                name={'discount'}
                                                label={'Em promoção'}
                                                placeholder='Em promoção'
                                                options={sn}
                                                defaultValue={item.discount ? '1' : '0'}
                                                onChange={(e, {value}) => {
                                                    setValue('discount', value);
                                                }}
                                            />
                                        </Form.Field>
                                        <Form.Field>
                                            <label>Parcelas ( sem juros )</label>
                                            <input
                                                name={'installments'}
                                                defaultValue={item.installments}
                                                ref={register({required: true})}
                                                type={"number"}
                                                step={"1"}
                                                disabled={free.toString() === '1' || free.toString() === 'true'}
                                                min={1}
                                                max={12}
                                            />
                                        </Form.Field>

                                    </Form.Group>
                                    <Form.Group widths={"equal"}>
                                        <Form.Field>
                                            <label>Preço original</label>
                                            <input
                                                name={'origin'}
                                                defaultValue={item.origin}
                                                ref={register({required: true})}
                                                type={"number"}
                                                step={"any"}
                                                // disabled={free.toString() === '1' || free.toString() === 'true'}
                                            />
                                        </Form.Field>

                                        <Form.Field>
                                            <label>Preço</label>
                                            <input
                                                name={'price'}
                                                defaultValue={item.price}
                                                ref={register({required: true})}
                                                type={"number"}
                                                step={"any"}
                                                disabled={free.toString() === '1' || free.toString() === 'true'}
                                            />
                                        </Form.Field>
                                        <Form.Field>
                                            <label>Peso ( GR )</label>
                                            <input
                                                name={'weight'}
                                                defaultValue={item.weight}
                                                ref={register({required: true})}
                                                type={"number"}
                                                step={"1"}
                                                min={1}
                                            />
                                        </Form.Field>
                                    </Form.Group>
                                    <Form.Group widths={"equal"}>
                                        <Form.Field>
                                            <label>Largura ( CM )</label>
                                            <input
                                                name={'width'}
                                                defaultValue={item.width}
                                                ref={register({required: true})}
                                                type={"number"}
                                                step={"any"}
                                                min={1}
                                            />
                                        </Form.Field>
                                        <Form.Field>
                                            <label>Altura ( CM )</label>
                                            <input
                                                name={'height'}
                                                defaultValue={item.height}
                                                ref={register({required: true})}
                                                type={"number"}
                                                step={"any"}
                                                min={1}
                                            />
                                        </Form.Field>
                                        <Form.Field>
                                            <label>Comprimento ( CM )</label>
                                            <input
                                                name={'length'}
                                                defaultValue={item.length}
                                                ref={register({required: true})}
                                                type={"number"}
                                                step={"any"}
                                                min={1}
                                            />
                                        </Form.Field>
                                    </Form.Group>
                                <Form.Group widths={"equal"}>
                                    <Form.Field>
                                        <label>CEP de Origem</label>
                                        <input
                                            name={'postal_code'}
                                            defaultValue={item.postal_code}
                                            ref={register({required: true})}
                                            type={"text"}
                                        />
                                    </Form.Field>
                                    <Form.Field>
                                        <Form.Select
                                            fluid
                                            name={'active'}
                                            label={'Produto Ativo'}
                                            placeholder='Gratuito'
                                            options={sn}
                                            defaultValue={item.active ? '1' : '0'}
                                            onChange={(e, {value}) => {
                                                setValue('active', value);
                                            }}
                                        />
                                    </Form.Field>
                                </Form.Group>
                                </Grid.Column>
                                <Grid.Column>
                                    <Form.Field>
                                        <label>Descrição curta</label>
                                        <textarea
                                            name={'description'}
                                            defaultValue={item.description}
                                            ref={register({required: true})}
                                            rows={6}
                                        />
                                    </Form.Field>
                                    <Form.Field>
                                        <label>Descrição completa</label>
                                        <Editor
                                            initialValue={item.content || ''}
                                            apiKey='2k98j4xwwxemv13rlpv08fkevjw8nq5wjq44loezdszu39mq'
                                            init={{
                                                height: 350,
                                                menubar: false,
                                                plugins: [
                                                    'advlist autolink lists link image charmap print preview anchor',
                                                    'searchreplace visualblocks code fullscreen',
                                                    'insertdatetime media table paste code help wordcount'
                                                ],
                                                toolbar:
                                                    'undo redo | formatselect | bold italic backcolor | \
                                                    alignleft aligncenter alignright alignjustify | \
                                                    bullist numlist outdent indent | removeformat | fullscreen'
                                            }}
                                            onEditorChange={(text) => setValue('content', text)}
                                        />
                                    </Form.Field>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Form>
                </Modal.Description>
            </Modal.Content>
            <Modal.Actions>
                <Button
                    basic
                    content={'Cancelar'}
                    onClick={onCancel}
                    disabled={formState.isSubmitting}
                />
                <Button
                    positive
                    content="Salvar"
                    disabled={formState.isSubmitting}
                    form={'form'}
                    loading={formState.isSubmitting}
                />
            </Modal.Actions>
        </Modal>
    )
}